import {getStyleManagerProperties} from "./StyleManager";
import {getDefaultCommands} from "./Commands";
import {getDefaultCanvas} from "./Canvas";

export const editorOptions = {
    domComponents: {draggableComponents: false},
    parser: {optionsHtml: {allowScripts: true}},
    width: '775px',
    plugins: [], customUI: true, showToolbar: true, storageManager: false,
    styleManager: getStyleManagerProperties(),
    assetManager: {assets: []},
    panels: {
        defaults: []
    },
    commands: getDefaultCommands(),
    deviceManager: {
        devices: [
            {name: 'Desktop'},
            {name: 'Accordion', width: '711px'},
            {name: 'Mobile', width: '400px'}
        ]
    },
    keymaps: {
        // Object of keymaps
        defaults: {
            'andar-detail:undo': {
                keys: '⌘+z, ctrl+z',
                handler: 'undo'
            },
            'andar-detail:redo': {
                keys: '⌘+shift+z, ctrl+shift+z',
                handler: 'redo'
            },
        }
    },
    canvas: getDefaultCanvas()
};


export const findParent = (component) => {
    const parent = component.parent();
    if (!parent || parent.attributes['tagName'] === 'body') {
        return component;
    }
    return findParent(parent);
}

export const findOneDepthParent = (component) => {
    const parent = component.parent();
    if (parent) {
        const parentParent = parent.parent();
        if (!parentParent || parentParent.attributes['tagName'] === 'body') {
            return component;
        }
        return findOneDepthParent(parent);
    } else {
        return undefined
    }
}

export const findCustomCmp = (component) => {
    if (component.getClasses().includes('swiper-slide') || component.getClasses().includes('color_btn') || component.getClasses().includes('tap_box_li') || component.getClasses().includes('accordion_table') || component.getClasses().includes('product-cta-list')) {
        return component;
    }
    const parent = component.parent();
    if (parent) {
        return findCustomCmp(parent);
    } else {
        return null;
    }
}
